import { englishLabels } from "./en";
import { hungarianLabels } from "./hu";

export type Labels = typeof hungarianLabels;

export type LabelLanguage = "hu" | "en";

export { englishLabels, hungarianLabels };

export const labelsByLanguage: Record<LabelLanguage, Labels> = { hu: hungarianLabels, en: englishLabels };

export function languageOf(langId: number): LabelLanguage {
  return langId === 2 ? "en" : "hu";
}

export function resolveLabels(lang: LabelLanguage, overrides?: Partial<Labels>): Labels {
  const result: Labels = { ...labelsByLanguage[lang] };

  if (!overrides) return result;

  for (const key of Object.keys(overrides) as (keyof Labels)[]) {
    const value = overrides[key];

    if (typeof value === "string" && value.length > 0) result[key] = value;
  }

  return result;
}

export function labelsFor(langId: number, overrides?: Partial<Labels>): Labels {
  return resolveLabels(languageOf(langId), overrides);
}

export function format(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (match, name: string) => (name in values ? String(values[name]) : match));
}
